import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, DeleteAccountModalIcon } from 'assets';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import { useDeleteUser } from 'view/pages/profile/hooks/useDeleteUser';

const ProfileDeleteAccountModal: FC<{ hideCloseButton?: boolean }> = ({
  hideCloseButton = false,
}) => {
  const isOpenDeleteAccountModal: boolean = useCS(
    ProfileConfigContext,
    profileConfigSelectors.isOpenDeleteAccountModal
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, send } = useDeleteUser();

  const onClose = () => {
    if (update) update({ isOpenDeleteAccountModal: false });
  };

  const onDeleteClick = () => {
    send();
  };

  return (
    <Modal
      open={isOpenDeleteAccountModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <DeleteAccountModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Sorry to see you go</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'Be advised, account deletion is final. \n There will be no way to restore your account.'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            className="red-button"
            variant="outlined"
            text="Delete Account"
            onClick={onDeleteClick}
            disabled={isLoading}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default ProfileDeleteAccountModal;
